import { render, staticRenderFns } from "./RefractiveDiscrepancyUserFuCha.vue?vue&type=template&id=6d0b7af9&scoped=true&"
import script from "./RefractiveDiscrepancyUserFuCha.vue?vue&type=script&lang=js&"
export * from "./RefractiveDiscrepancyUserFuCha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0b7af9",
  null
  
)

export default component.exports